import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styles from './styles.module.scss';
import { EmojiProvider, Emoji } from "react-apple-emojis"
import emojiData from "react-apple-emojis/src/data.json"

const content = () => {

  return (
    <EmojiProvider data={emojiData}>
      <div className={styles.container}>
        <div className={styles.title}>Applying For Your TIE In Spain</div>
        <div className={styles.paragraph}>
        If you're moving to Spain for an extended period, obtaining your TIE (Tarjeta de Identidad de Extranjero) is essential. <br/>
        The TIE is a residence card for non-EU citizens, which serves as proof of your legal residency in Spain. <br/>
        Here’s a clear guide on how to get your TIE number.</div>
        <br/><br/>
        <iframe width="650" height="315" 
        src="https://www.youtube.com/embed/ZkEsQHt-ROg?si=ESi8qAl3QJvUfp9q" 
        title="TIE Application" frameborder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <br/><br/>
        <div className={styles.subtitle}>1. Understand the Purpose of the TIE</div>
        <div className={styles.paragraph}>
        The TIE serves as a tax identification number for foreigners in Spain. <br/>
        It is required for almost any legal activity, such as buying property, setting up utilities, or conducting business. <br/>
        You will need this to be employed or to register as an Autonomo in Spain.
        </div>

        <div className={styles.subtitle}>2. Prepare Your Documents</div>
        <div className={styles.paragraph}>
        Before applying, gather the necessary documents:
        <br/>
        <list>
          <li>Valid Passport: A copy of your passport (and the original).</li>
          <li>NIE Number: Your NIE (Número de Identificación de Extranjero) is required.</li>
          <li>Completed Application Form: Fill out the EX-17 form, which can usually be downloaded from the official website or obtained at the office.</li>
          <li>Proof of Residency or Purpose: A document demonstrating your reason for needing the TIE (e.g., employment contract, student enrollment, or proof of property purchase).</li>
          <li>Passport-sized Photos: Depending on the office, you may need to provide recent passport-sized photographs.</li>
        </list>
        </div>

        <div className={styles.subtitle}>3. Book an Appointment</div>
        <div className={styles.paragraph}>
        To streamline the process, it's advisable to book an appointment (cita previa) online through the Spanish police or immigration website. <br/>
        Appointments can fill up quickly, so try to book as soon as you arrive in Spain. <br/>
        More information can be found at <a href='https://www.inclusion.gob.es/web/migraciones/w/tarjeta-de-identidad-de-extranjero-tie-hi92-'>the official government website</a>.
        </div>

        <div className={styles.subtitle}>4. Pay The Fee</div>
        <div className={styles.paragraph}>
        There is usually a small fee for obtaining your NIE, which varies depending on the province. <br/>
        Payment can often be made at the bank, where you’ll receive a payment form to fill out. The 790-012 form is used to pay the fees associated with various administrative procedures, including your NIE application. <br/>
        It must be completed, printed, and attached to the EX-15 form.
        </div>

        <div className={styles.subtitle}>5. Visit the Designated Office</div>
        <div className={styles.paragraph}>
        On the day of your appointment, go to the designated police station or immigration office. <br/>
        This address will be given to you when you make your appointment and varies by region. <br/>
        Bring all your documents and be prepared for a potential wait. Be punctual, as lateness can result in rescheduling.
        </div>

        <div className={styles.subtitle}>6. Receive Your NIE</div>
        <div className={styles.paragraph}>
        Once your application is processed, you will receive your NIE number. <br/>
        This can take a few minutes to a few days, depending on the office. <br/>
        Make sure to keep the document safe, as you’ll need it for various transactions in Spain.
        </div>

        <div className={styles.paragraph}>
        Obtaining your NIE number is a crucial step when moving to Spain. By preparing your documents, booking an appointment, and following the process, you can ensure a smooth experience. <br/>
        Once you have your NIE, you’ll be well-equipped to navigate your new life in Spain!
        </div>
      </div>
    </EmojiProvider>
  )
}

export default content
